import React from "react";
import PropTypes from "prop-types";
import { FormRow } from "./FormRow";
import { FormTextareaField } from "@arcteryx/components-form";

export const TextAreaInput = ({ id, label, required, register }) => (
  <FormRow>
    <FormTextareaField
      name={id}
      data-testid={id}
      type="text"
      id={id}
      label={label}
      required={required}
      valid
      {...register(id)}
      error
    />
  </FormRow>
);

TextAreaInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  register: PropTypes.func.isRequired
};

export default TextAreaInput;
